import {ClickType} from '@vio/core/src/analytics/types/Events'

export const MIDDLE_MOUSE_BUTTON = 1

/**
 * A long press on touch devices surfaces as a `contextmenu` event, the same as
 * a desktop right click. Chrome and Firefox report it as a PointerEvent we can
 * read `pointerType` from; Safari sends a plain MouseEvent, so fall back to the
 * pointer capability of the device.
 */
const isTouchTriggered = (event: React.MouseEvent) => {
  const {nativeEvent} = event

  if (
    typeof PointerEvent !== 'undefined' &&
    nativeEvent instanceof PointerEvent
  )
    return nativeEvent.pointerType === 'touch'

  return window.matchMedia?.('(pointer: coarse)').matches ?? false
}

export const getClickType = (event: React.MouseEvent): ClickType => {
  if (event.type === 'contextmenu')
    return isTouchTriggered(event) ? ClickType.LongPress : ClickType.RightClick

  if (event.button === MIDDLE_MOUSE_BUTTON) return ClickType.MiddleClick

  return ClickType.LeftClick
}

/**
 * `auxclick` also fires for the back and forward mouse buttons, which navigate
 * history rather than opening the link. Tracking those would create a lead for
 * a click that never opened anything.
 */
export const isTrackableAlternativeClick = (event: React.MouseEvent) =>
  event.type !== 'auxclick' || event.button === MIDDLE_MOUSE_BUTTON
